import * as angular from 'angular';

class OsItemController {
  private name: string;

  static $inject = [];
  constructor() {}
}

const OsItemComponent: angular.IComponentOptions = {
  controller: OsItemController,
  controllerAs: 'ctrl',
  bindings: {
    name: '@',
  },
  template: `
    <div class="selector-item-container">
      <div class="individual-selector-name">{{ ctrl.name }}</div>
      <div class="os-icon"><i class="icon-os-item-checkmark-default"></i></div>
    </div>
  `,
};

angular.module('mode.components').component('osItem', OsItemComponent);
